import { Dayjs } from "dayjs";
import { parsePhoneNumber } from 'libphonenumber-js';
import { ITrade } from 'src/services/interface/trade/ITrade';
import { EstadoCivilEnum } from 'src/services/enum/EstadoCivilEnum';
import { PropertyRegimeEnum } from 'src/services/enum/PropertyRegimeEnum';
import { IDocument } from 'src/services/interface/IDocument';
import { DocumentCategoryEnum } from 'src/services/enum/DocumentCategoryEnum';
import { FilesCategoryEnum } from 'src/services/enum/FilesCategoryEnum';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';

export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const cpfRegex = /^((\d{3}\.?){3}\-?(\d){2})$/i

export const removeSpecialCharacter = (str: string) => str.replace(/[^a-zA-Z]/g, '').toLowerCase();
export const alphabeticallySort = (a: string, b: string) => (a < b ? -1 : a > b ? 1 : 0);
export const dateSort = (a: Dayjs, b: Dayjs) => (a < b ? -1 : a > b ? 1 : 0); // Date sort Descending
export const validateEmail = (email: string): boolean => emailRegex.test(String(email).toLowerCase())
export const validateCpf = (cpf: string): boolean => cpfRegex.test(String(cpf).toLowerCase())

export const validateIp = (ip: string): boolean => {
	return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip);
};

export const validatePhoneNumber = (value, region): boolean => {
	try {
		return parsePhoneNumber(value, region).isValid();
	} catch (e) {
		return false;
	}
};

/**
 * Serializa lista de query string
 * @param list Lista de valores para ser serializada
 * @param indetifier indetificador (nome do parametro que o back espera)
 */
export const generateQueryStringList = (list, indetifier) => {
	if (list == null) {
		return '';
	}

	let query = '';
	list.forEach(element => {
		query += `${indetifier}=${element}&`;
	});

	return query.substring(0, query.length - 1);
};

function createQueryString(obj: any, forceKey = null): string {
	let queryString = "";
	let flag = false;

	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			if (value == null || (value.constructor.name === "Array" && value.length === 0)) {
				continue;
			}
			if (flag) {
				queryString += "&";
			}

			if (value && value.constructor.name === "Object") {
				queryString += createQueryString(value);
			} else if (value && value.constructor.name === "Array") {
				queryString += createQueryString(value, key);
			} else {
				queryString += `${forceKey ? forceKey : key}=${value}`;
			}

			flag = true;
		}
	}
	return queryString;
}

export const generateQueryString = (obj: any): string => createQueryString(obj);

export const formatCurrency = new Intl.NumberFormat('pt-BR', {
	style: 'currency',
	currency: 'BRL',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
}).format;

export function userHaveSpouse(trade: ITrade): boolean {
	if (trade.tradeOwner) {
		const isMarried = trade.tradeOwner.civilStatus === EstadoCivilEnum.casado || trade.tradeOwner.civilStatus === EstadoCivilEnum.uniao_estavel;
		const hasPropertyRegime =
			(trade.tradeOwner && trade.tradeOwner.propertyRegime === PropertyRegimeEnum.ComunhaoParcial) || trade.tradeOwner.propertyRegime === PropertyRegimeEnum.ComunhaoTotal;
		return isMarried && hasPropertyRegime;
	} else {
		return false;
	}
}

export function userHaveDocument(documents: IDocument[], category: DocumentCategoryEnum | FilesCategoryEnum): boolean {
	if (documents) {
		return documents.some(doc => doc.category === category);
	} else {
		return false;
	}
}

export function findDocumentByCategory(documents: IDocument[], category: DocumentCategoryEnum | FilesCategoryEnum): IDocument {
	if (documents) {
		const foundDocument = documents.find(doc => doc.category === category);
		return foundDocument ? foundDocument : null;
	} else {
		return null;
	}
}

export async function validateForm(props): Promise<boolean> {
	try {
		await props.formInstance.validateFields();
		return true;
	} catch (err) {
		ShowNotification.Warn('Formulário inválido!', 'Por favor, informe todos os campos obrigatórios.');
		return false;
	}
}

export function verifyIsReducedPercentLender(reducedPercent: number): boolean {
	let isReduced = false;
	if (reducedPercent) {
		if (reducedPercent < 1) {
			isReduced = true;
		}
	}
	return isReduced;
}


export function findDocumentsInTradeByCategory(tradeDocumentList: IDocument[], documentsCategoryToFind: DocumentCategoryEnum[]): IDocument[] {
	const documentsFinded: IDocument[] = [];

	if (tradeDocumentList && documentsCategoryToFind) {
		documentsCategoryToFind.forEach(category => {
			const documentFinded = tradeDocumentList.find(tradeDocument => tradeDocument.category === DocumentCategoryEnum[category]);

			if (documentFinded) {
				documentsFinded.push(documentFinded);
			}
		});
	}

	return documentsFinded;
}

export const hasUpperCaseCharacters = (text: string): boolean => /[A-Z]+/.test(text);

export const isCnpj = (cnpj: string): boolean => {
	const testCnpj = /^[A-Za-z0-9]{14}$/;

	return testCnpj.test(cnpj);
}

export const isCpf = (cpf: string): boolean => {
	const testCpf = /^\d{11}$/;

	return testCpf.test(cpf);
}